import { render, staticRenderFns } from "./RateDatatable.vue?vue&type=template&id=612501b4&scoped=true"
import script from "./RateDatatable.vue?vue&type=script&lang=js"
export * from "./RateDatatable.vue?vue&type=script&lang=js"
import style0 from "./RateDatatable.vue?vue&type=style&index=0&id=612501b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612501b4",
  null
  
)

export default component.exports